// // ============================================================
// // src/components/admin/PricingTab.js
// // ✅ Passes hospitalId to fetch THIS hospital's pricing only
// // ============================================================
// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";

// const DEFAULT_PRICING = [
//   {
//     icon: "🦷",
//     name: "Essential Care",
//     price: "Rs. 500",
//     from: true,
//     featured: false,
//     features: [
//       "Oral Examination",
//       "Professional Cleaning",
//       "X-Ray (2 films)",
//       "Cavity Check",
//       "Treatment Plan",
//       "Follow-up Reminder",
//     ],
//   },
//   {
//     icon: "⭐",
//     name: "Smile Makeover",
//     price: "Rs. 3,500",
//     from: true,
//     featured: true,
//     features: [
//       "Teeth Whitening (1 hr)",
//       "Composite Bonding",
//       "Gum Contouring",
//       "Digital Smile Design",
//       "Post-care Kit",
//       "3-Month Follow-up",
//     ],
//   },
//   {
//     icon: "💎",
//     name: "Implant Package",
//     price: "Rs. 25,000",
//     from: true,
//     featured: false,
//     features: [
//       "Titanium Implant",
//       "3D Cone Beam CT Scan",
//       "Custom Crown",
//       "Bone Grafting (if needed)",
//       "Lifetime Warranty",
//       "Priority Scheduling",
//     ],
//   },
// ];

// // ✅ Get hospitalId from JWT token
// function getHospitalIdFromToken() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     const key = slug
//       ? `pearlsmile_token_${slug}`
//       : "pearlsmile_token_pearlsmile";
//     const token = localStorage.getItem(key);
//     if (!token) return null;
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     return payload?.hospitalId || null;
//   } catch {
//     return null;
//   }
// }

// export default function PricingTab({ showNotify }) {
//   const [pricing, setPricing] = useState([]);
//   const [priceToast, setPriceToast] = useState(false);

//   useEffect(() => {
//     // ✅ Pass hospitalId to get THIS hospital's pricing
//     const hospitalId = getHospitalIdFromToken();
//     const url = hospitalId ? `/pricing?hospitalId=${hospitalId}` : `/pricing`;
//     api
//       .get(url)
//       .then((data) => setPricing(data?.length > 0 ? data : DEFAULT_PRICING))
//       .catch(() => setPricing(DEFAULT_PRICING));
//   }, []);

//   const update = (i, key, val) =>
//     setPricing((prev) =>
//       prev.map((p, idx) => (idx === i ? { ...p, [key]: val } : p)),
//     );

//   const updateFeatures = (i, textareaVal) =>
//     update(
//       i,
//       "features",
//       textareaVal.split("\n").filter((l) => l.trim()),
//     );

//   const addRow = () => {
//     setPricing((prev) => [
//       ...prev,
//       {
//         icon: "🦷",
//         name: "New Package",
//         price: "Rs. 0",
//         from: true,
//         featured: false,
//         features: ["Feature 1", "Feature 2", "Feature 3"],
//       },
//     ]);
//     showNotify(
//       "Pricing Card Added",
//       "Fill in the details and click Save & Update Live.",
//     );
//   };

//   const deleteRow = (i) => {
//     if (window.confirm("Delete this pricing card?"))
//       setPricing((prev) => prev.filter((_, idx) => idx !== i));
//   };

//   const save = async () => {
//     try {
//       await api.put("/pricing", { list: pricing });
//       if (typeof window.__refreshPricing === "function")
//         window.__refreshPricing();
//       showNotify(
//         "Pricing Saved! ✓",
//         "Pricing cards updated and live on the website.",
//       );
//       setPriceToast(true);
//       setTimeout(() => setPriceToast(false), 3000);
//     } catch (err) {
//       showNotify("Save Failed", err.message, true);
//     }
//   };

//   return (
//     <div>
//       <div className="admin-section-title">Pricing Editor</div>
//       <div className="admin-section-desc">
//         Edit pricing cards. Click "Save & Update Live" to update the Pricing
//         section instantly.
//       </div>
//       <div className="admin-pricing-list">
//         {pricing.map((p, i) => (
//           <div className="admin-pricing-row" key={i}>
//             <div>
//               <div className="admin-row-label">Package Name</div>
//               <input
//                 type="text"
//                 value={p.name}
//                 onChange={(e) => update(i, "name", e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "10px 14px",
//                   border: "1.5px solid var(--gray-200)",
//                   borderRadius: 8,
//                   fontFamily: "DM Sans,sans-serif",
//                   fontSize: 13,
//                   outline: "none",
//                 }}
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Icon (emoji)</div>
//               <input
//                 type="text"
//                 value={p.icon}
//                 onChange={(e) => update(i, "icon", e.target.value)}
//                 style={{
//                   width: 80,
//                   padding: "10px 14px",
//                   border: "1.5px solid var(--gray-200)",
//                   borderRadius: 8,
//                   fontFamily: "DM Sans,sans-serif",
//                   fontSize: 13,
//                   outline: "none",
//                 }}
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Starting Price</div>
//               <input
//                 type="text"
//                 value={p.price}
//                 onChange={(e) => update(i, "price", e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "10px 14px",
//                   border: "1.5px solid var(--gray-200)",
//                   borderRadius: 8,
//                   fontFamily: "DM Sans,sans-serif",
//                   fontSize: 13,
//                   outline: "none",
//                 }}
//               />
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 16,
//                 marginTop: 20,
//               }}
//             >
//               <label className="admin-featured-toggle">
//                 <input
//                   type="checkbox"
//                   checked={!!p.featured}
//                   onChange={(e) => update(i, "featured", e.target.checked)}
//                 />{" "}
//                 Mark as Featured
//               </label>
//               <button className="admin-del-btn" onClick={() => deleteRow(i)}>
//                 ✕
//               </button>
//             </div>
//             <div style={{ gridColumn: "span 2" }}>
//               <div className="admin-row-label">Features (one per line)</div>
//               <textarea
//                 value={(p.features || []).join("\n")}
//                 onChange={(e) => updateFeatures(i, e.target.value)}
//                 style={{
//                   width: "100%",
//                   height: 110,
//                   padding: "10px 14px",
//                   border: "1.5px solid var(--gray-200)",
//                   borderRadius: 8,
//                   fontFamily: "DM Sans,sans-serif",
//                   fontSize: 13,
//                   resize: "vertical",
//                   outline: "none",
//                 }}
//               />
//             </div>
//           </div>
//         ))}
//       </div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <button className="admin-add-btn" onClick={addRow}>
//           + Add Pricing Card
//         </button>
//         <button className="admin-save-btn" onClick={save}>
//           Save & Update Live →
//         </button>
//         <span className={`admin-saved-toast${priceToast ? " show" : ""}`}>
//           ✅ Changes saved and live!
//         </span>
//       </div>
//     </div>
//   );
// }

// ============================================================
// src/components/admin/PricingTab.js
// ✅ Specialty-specific defaults in admin panel
// ============================================================
import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import { useHospital } from "../../context/HospitalContext";

const DEFAULT_PRICING_BY_TYPE = {
  dental: [
    {
      icon: "🦷",
      name: "Essential Care",
      price: "Rs. 500",
      from: true,
      featured: false,
      features: [
        "Oral Examination",
        "Professional Cleaning",
        "X-Ray (2 films)",
        "Cavity Check",
        "Treatment Plan",
        "Follow-up Reminder",
      ],
    },
    {
      icon: "⭐",
      name: "Smile Makeover",
      price: "Rs. 3,500",
      from: true,
      featured: true,
      features: [
        "Teeth Whitening (1 hr)",
        "Composite Bonding",
        "Gum Contouring",
        "Digital Smile Design",
        "Post-care Kit",
        "3-Month Follow-up",
      ],
    },
    {
      icon: "💎",
      name: "Implant Package",
      price: "Rs. 25,000",
      from: true,
      featured: false,
      features: [
        "Titanium Implant",
        "3D Cone Beam CT Scan",
        "Custom Crown",
        "Bone Grafting (if needed)",
        "Lifetime Warranty",
        "Priority Scheduling",
      ],
    },
  ],
  ayurved: [
    {
      icon: "🌿",
      name: "Wellness Starter",
      price: "Rs. 1,500",
      from: true,
      featured: false,
      features: [
        "Prakriti Analysis",
        "Dosha Assessment",
        "Herbal Consultation",
        "Diet Plan",
        "Follow-up Call",
        "Home Remedy Guide",
      ],
    },
    {
      icon: "⭐",
      name: "Panchakarma Detox",
      price: "Rs. 8,000",
      from: true,
      featured: true,
      features: [
        "Abhyanga Massage",
        "Shirodhara Therapy",
        "Nasya Treatment",
        "Herbal Steam Bath",
        "Medicated Diet Plan",
        "7-Day Program",
      ],
    },
    {
      icon: "💎",
      name: "Complete Wellness",
      price: "Rs. 18,000",
      from: true,
      featured: false,
      features: [
        "Full Panchakarma",
        "Rasayana Therapy",
        "Herbal Medicines",
        "Yoga & Pranayama",
        "21-Day Program",
        "Priority Support",
      ],
    },
  ],
  ortho: [
    {
      icon: "🦴",
      name: "OPD Consultation",
      price: "Rs. 800",
      from: true,
      featured: false,
      features: [
        "Orthopedic Assessment",
        "X-Ray Review",
        "Pain Diagnosis",
        "Treatment Planning",
        "Physiotherapy Advice",
        "Follow-up",
      ],
    },
    {
      icon: "⭐",
      name: "Joint Care Package",
      price: "Rs. 15,000",
      from: true,
      featured: true,
      features: [
        "MRI/CT Scan Review",
        "Specialist Consultation",
        "Injection Therapy",
        "Physiotherapy (10 sessions)",
        "Custom Brace",
        "Monthly Follow-up",
      ],
    },
    {
      icon: "💎",
      name: "Surgical Package",
      price: "Rs. 1,20,000",
      from: true,
      featured: false,
      features: [
        "Joint Replacement Surgery",
        "Pre-op Assessment",
        "Post-op Physio",
        "6-Month Rehab",
        "Implant Warranty",
        "24/7 Support",
      ],
    },
  ],
  eye: [
    {
      icon: "👁️",
      name: "Eye Checkup",
      price: "Rs. 500",
      from: true,
      featured: false,
      features: [
        "Comprehensive Eye Test",
        "Visual Acuity Check",
        "IOP Measurement",
        "Fundus Examination",
        "Spectacle Prescription",
        "Follow-up",
      ],
    },
    {
      icon: "⭐",
      name: "LASIK Package",
      price: "Rs. 35,000",
      from: true,
      featured: true,
      features: [
        "Pre-LASIK Screening",
        "Bladeless LASIK Surgery",
        "Both Eyes Covered",
        "Post-op Medications",
        "3-Month Follow-up",
        "Lifetime Enhancement",
      ],
    },
    {
      icon: "💎",
      name: "Cataract Surgery",
      price: "Rs. 45,000",
      from: true,
      featured: false,
      features: [
        "Phacoemulsification",
        "Premium IOL Implant",
        "Both Eyes",
        "Pre & Post-op Care",
        "Priority Scheduling",
        "1-Year Follow-up",
      ],
    },
  ],
  cardiology: [
    {
      icon: "❤️",
      name: "Cardiac Checkup",
      price: "Rs. 2,500",
      from: true,
      featured: false,
      features: [
        "ECG",
        "Echocardiography",
        "BP Check",
        "Cholesterol Test",
        "Cardiologist Consultation",
        "Diet Plan",
      ],
    },
    {
      icon: "⭐",
      name: "Heart Care Package",
      price: "Rs. 12,000",
      from: true,
      featured: true,
      features: [
        "Stress Test TMT",
        "2D Echo",
        "Holter Monitoring",
        "Lipid Profile",
        "Specialist Review",
        "3-Month Follow-up",
      ],
    },
    {
      icon: "💎",
      name: "Angioplasty Package",
      price: "Rs. 2,50,000",
      from: true,
      featured: false,
      features: [
        "Coronary Angiography",
        "Angioplasty & Stenting",
        "ICU Care",
        "Post-op Medications",
        "Cardiac Rehab",
        "6-Month Follow-up",
      ],
    },
  ],
  pediatric: [
    {
      icon: "👶",
      name: "Well Baby Checkup",
      price: "Rs. 500",
      from: true,
      featured: false,
      features: [
        "Growth Monitoring",
        "Developmental Assessment",
        "Vaccination Review",
        "Nutrition Counseling",
        "Parent Guidance",
        "Follow-up",
      ],
    },
    {
      icon: "⭐",
      name: "Child Health Package",
      price: "Rs. 3,000",
      from: true,
      featured: true,
      features: [
        "Complete Blood Count",
        "Urine Analysis",
        "Pediatric Consultation",
        "Immunization Update",
        "Diet Plan",
        "Monthly Follow-up",
      ],
    },
    {
      icon: "💎",
      name: "Annual Health Plan",
      price: "Rs. 8,000",
      from: true,
      featured: false,
      features: [
        "4 Quarterly Checkups",
        "All Vaccinations",
        "Growth Chart Tracking",
        "School Health Certificate",
        "Priority Access",
        "24/7 Helpline",
      ],
    },
  ],
  general: [
    {
      icon: "🏥",
      name: "General OPD",
      price: "Rs. 500",
      from: true,
      featured: false,
      features: [
        "Doctor Consultation",
        "Basic Examination",
        "Prescription",
        "Health Advice",
        "Follow-up Reminder",
        "Lab Referral if needed",
      ],
    },
    {
      icon: "⭐",
      name: "Health Checkup Package",
      price: "Rs. 4,500",
      from: true,
      featured: true,
      features: [
        "Complete Blood Count",
        "Blood Sugar & Lipids",
        "Liver & Kidney Function",
        "ECG",
        "Chest X-Ray",
        "Doctor Review & Report",
      ],
    },
    {
      icon: "💎",
      name: "Comprehensive Plan",
      price: "Rs. 12,000",
      from: true,
      featured: false,
      features: [
        "Full Body Checkup",
        "Specialist Consultation",
        "Ultrasound Abdomen",
        "Thyroid Profile",
        "Annual Membership",
        "Priority Scheduling",
      ],
    },
  ],
};

function getHospitalIdFromToken() {
  try {
    const path = window.location.pathname;
    const match = path.match(/\/hospital\/([^/]+)/);
    const slug = match ? match[1] : null;
    const key = slug
      ? `pearlsmile_token_${slug}`
      : "pearlsmile_token_pearlsmile";
    const token = localStorage.getItem(key);
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.hospitalId || null;
  } catch {
    return null;
  }
}

export default function PricingTab({ showNotify }) {
  const { hospital } = useHospital();
  const type = (hospital?.type || "dental").toLowerCase();
  const defaultPricing =
    DEFAULT_PRICING_BY_TYPE[type] || DEFAULT_PRICING_BY_TYPE.dental;

  const [pricing, setPricing] = useState([]);
  const [priceToast, setPriceToast] = useState(false);

  useEffect(() => {
    const hospitalId = getHospitalIdFromToken();
    const url = hospitalId ? `/pricing?hospitalId=${hospitalId}` : `/pricing`;
    api
      .get(url)
      .then((data) => setPricing(data?.length > 0 ? data : defaultPricing))
      .catch(() => setPricing(defaultPricing));
  }, [hospital?.type]); // ✅ Re-load when hospital type changes

  const update = (i, key, val) =>
    setPricing((prev) =>
      prev.map((p, idx) => (idx === i ? { ...p, [key]: val } : p)),
    );

  const updateFeatures = (i, textareaVal) =>
    update(
      i,
      "features",
      textareaVal.split("\n").filter((l) => l.trim()),
    );

  const addRow = () => {
    setPricing((prev) => [
      ...prev,
      {
        icon: "🏥",
        name: "New Package",
        price: "Rs. 0",
        from: true,
        featured: false,
        features: ["Feature 1", "Feature 2", "Feature 3"],
      },
    ]);
    showNotify(
      "Pricing Card Added",
      "Fill in the details and click Save & Update Live.",
    );
  };

  const deleteRow = (i) => {
    if (window.confirm("Delete this pricing card?"))
      setPricing((prev) => prev.filter((_, idx) => idx !== i));
  };

  const save = async () => {
    try {
      await api.put("/pricing", { list: pricing });
      if (typeof window.__refreshPricing === "function")
        window.__refreshPricing();
      showNotify(
        "Pricing Saved! ✓",
        "Pricing cards updated and live on the website.",
      );
      setPriceToast(true);
      setTimeout(() => setPriceToast(false), 3000);
    } catch (err) {
      showNotify("Save Failed", err.message, true);
    }
  };

  return (
    <div>
      <div className="admin-section-title">Pricing Editor</div>
      <div className="admin-section-desc">
        Edit pricing cards. Click "Save & Update Live" to update instantly.
      </div>
      <div className="admin-pricing-list">
        {pricing.map((p, i) => (
          <div className="admin-pricing-row" key={i}>
            <div>
              <div className="admin-row-label">Package Name</div>
              <input
                type="text"
                value={p.name}
                onChange={(e) => update(i, "name", e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  border: "1.5px solid var(--gray-200)",
                  borderRadius: 8,
                  fontFamily: "DM Sans,sans-serif",
                  fontSize: 13,
                  outline: "none",
                }}
              />
            </div>
            <div>
              <div className="admin-row-label">Icon (emoji)</div>
              <input
                type="text"
                value={p.icon}
                onChange={(e) => update(i, "icon", e.target.value)}
                style={{
                  width: 80,
                  padding: "10px 14px",
                  border: "1.5px solid var(--gray-200)",
                  borderRadius: 8,
                  fontFamily: "DM Sans,sans-serif",
                  fontSize: 13,
                  outline: "none",
                }}
              />
            </div>
            <div>
              <div className="admin-row-label">Starting Price</div>
              <input
                type="text"
                value={p.price}
                onChange={(e) => update(i, "price", e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  border: "1.5px solid var(--gray-200)",
                  borderRadius: 8,
                  fontFamily: "DM Sans,sans-serif",
                  fontSize: 13,
                  outline: "none",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                marginTop: 20,
              }}
            >
              <label className="admin-featured-toggle">
                <input
                  type="checkbox"
                  checked={!!p.featured}
                  onChange={(e) => update(i, "featured", e.target.checked)}
                />{" "}
                Mark as Featured
              </label>
              <button className="admin-del-btn" onClick={() => deleteRow(i)}>
                ✕
              </button>
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <div className="admin-row-label">Features (one per line)</div>
              <textarea
                value={(p.features || []).join("\n")}
                onChange={(e) => updateFeatures(i, e.target.value)}
                style={{
                  width: "100%",
                  height: 110,
                  padding: "10px 14px",
                  border: "1.5px solid var(--gray-200)",
                  borderRadius: 8,
                  fontFamily: "DM Sans,sans-serif",
                  fontSize: 13,
                  resize: "vertical",
                  outline: "none",
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <button className="admin-add-btn" onClick={addRow}>
          + Add Pricing Card
        </button>
        <button className="admin-save-btn" onClick={save}>
          Save & Update Live →
        </button>
        <span className={`admin-saved-toast${priceToast ? " show" : ""}`}>
          ✅ Changes saved and live!
        </span>
      </div>
    </div>
  );
}
